// BEGIN seibertronwpc5SafetyGalleryGalleryRestore20260714
;(function seibertronwpc5SafetyGalleryGalleryRestore20260714() {
  var config = {
  "handle": "seibertron-high-vis-wpc5-anti-cut-gloves",
  "entries": [
    {
      "key": "main-white",
      "id": "33448636317886",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-wpc5-safety-gloves-main-white-20260715.jpg?v=1784080957",
      "alt": "seibertron-gallery:wpc5-safety-gloves-20260715 | product:wpc5 | color:Green Red | slot:1 | Seibertron HIGH-VIS WPC5 safety gloves white background product image"
    },
    {
      "key": "overview",
      "id": "33448636350654",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-wpc5-safety-gloves-overview-20260715.jpg?v=1784080957",
      "alt": "seibertron-gallery:wpc5-safety-gloves-20260715 | product:wpc5 | color:Green Red | slot:2 | Seibertron HIGH-VIS WPC5 safety gloves high-vis oil and gas overview image"
    },
    {
      "key": "impact-rating",
      "id": "33448636383422",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-wpc5-safety-gloves-impact-rating-20260715.jpg?v=1784080957",
      "alt": "seibertron-gallery:wpc5-safety-gloves-20260715 | product:wpc5 | color:Green Red | slot:3 | Seibertron HIGH-VIS WPC5 safety gloves TPR impact protection and CE ANSI rating detail image"
    },
    {
      "key": "palm-clip",
      "id": "33448636416190",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-wpc5-safety-gloves-palm-clip-20260715.jpg?v=1784080957",
      "alt": "seibertron-gallery:wpc5-safety-gloves-20260715 | product:wpc5 | color:Green Red | slot:4 | Seibertron HIGH-VIS WPC5 safety gloves palm and glove clip detail image"
    },
    {
      "key": "detail-panels",
      "id": "33448636448958",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-wpc5-safety-gloves-detail-panels-20260715.jpg?v=1784080957",
      "alt": "seibertron-gallery:wpc5-safety-gloves-20260715 | product:wpc5 | color:Green Red | slot:5 | Seibertron HIGH-VIS WPC5 safety gloves product detail panels"
    },
    {
      "key": "best-use",
      "id": "33448636481726",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-wpc5-safety-gloves-best-use-20260715.jpg?v=1784080957",
      "alt": "seibertron-gallery:wpc5-safety-gloves-20260715 | product:wpc5 | color:Green Red | slot:6 | Seibertron HIGH-VIS WPC5 safety gloves best use application image"
    },
    {
      "key": "size-chart",
      "id": "33448636514494",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-wpc5-safety-gloves-size-chart-20260715.jpg?v=1784080957",
      "alt": "seibertron-gallery:wpc5-safety-gloves-20260715 | product:wpc5 | color:Green Red | slot:7 | Seibertron HIGH-VIS WPC5 safety gloves adult size chart image"
    }
  ],
  "styleThumbs": {
    "WPC5": "33448636317886",
    "WPC5+1 Glove Clip": "33448636416190"
  }
};
  var entryById = {};
  config.entries.forEach(function (entry) { entryById[String(entry.id)] = entry; });
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    var nextSrc = sized(entry.src, 1200);
    if ((main.currentSrc || main.src || '') !== nextSrc) main.src = nextSrc;
    if (main.srcset) main.srcset = '';
    if ((entry.alt || '') && main.alt !== entry.alt) main.alt = entry.alt;
  }
  function ensureStyle() {
    var id = 'wpc5-safety-gallery-restore-20260715-style';
    if (document.getElementById(id)) return;
    var style = document.createElement('style');
    style.id = id;
    style.textContent = '.auto-product[data-product-handle="' + config.handle + '"] [data-auto-visual-option-value] [data-auto-choice-label]{width:78px;height:78px;min-width:78px;padding:0!important;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#fff;color:transparent!important;font-size:0!important;line-height:0!important}.auto-product[data-product-handle="' + config.handle + '"] .auto-product__swatch-image{width:100%;height:100%;display:block}.auto-product[data-product-handle="' + config.handle + '"] .auto-product__swatch-image img{width:100%;height:100%;object-fit:contain;background:#fff;display:block}.auto-product[data-product-handle="' + config.handle + '"] .auto-product__swatch-label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}';
    document.head.appendChild(style);
  }
  function ensureThumb(scope, wrap, entry, index) {
    var id = String(entry.id);
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    var fullSrc = sized(entry.src, 1200);
    var thumbSrc = sized(entry.src, 180);
    if (thumb.getAttribute('data-src') !== fullSrc) thumb.setAttribute('data-src', fullSrc);
    if (thumb.getAttribute('data-alt') !== (entry.alt || '')) thumb.setAttribute('data-alt', entry.alt || '');
    if (thumb.hidden) thumb.hidden = false;
    if (thumb.style.display) thumb.style.display = '';
    if (thumb.getAttribute('aria-hidden') !== 'false') thumb.setAttribute('aria-hidden', 'false');
    if (thumb.dataset.wpc5SafetyGalleryThumbReady !== id) {
      thumb.innerHTML = '<img src="' + escapeHtml(thumbSrc) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
      thumb.dataset.wpc5SafetyGalleryThumbReady = id;
    }
    if (!thumb.dataset.wpc5SafetyGalleryGalleryBound) {
      thumb.dataset.wpc5SafetyGalleryGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrateGallery(scope) {
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    var visibleIds = {};
    config.entries.forEach(function (entry, index) {
      var thumb = ensureThumb(scope, wrap, entry, index);
      visibleIds[String(entry.id)] = true;
      thumb.classList.toggle('is-active', index === 0);
    });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var show = !!visibleIds[String(thumb.getAttribute('data-media-id') || '')];
      thumb.hidden = !show;
      thumb.style.display = show ? '' : 'none';
      var hiddenValue = show ? 'false' : 'true';
      if (thumb.getAttribute('aria-hidden') !== hiddenValue) thumb.setAttribute('aria-hidden', hiddenValue);
    });
    setMain(scope, config.entries[0]);
  }
  function hydrateStyleChoices(scope) {
    Object.keys(config.styleThumbs || {}).forEach(function (value) {
      var entry = entryById[String(config.styleThumbs[value] || '')];
      if (!entry) return;
      scope.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
        if ((label.getAttribute('data-auto-visual-option-value') || '') !== value) return;
        var shell = label.querySelector('[data-auto-choice-label]');
        if (!shell) return;
        label.classList.add('auto-product__choice--visual');
        shell.dataset.display = value;
        if (shell.dataset.wpc5SafetyGalleryStyleThumb === String(entry.id) && shell.querySelector('img')) return;
        shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(value) + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(value) + '" width="72" height="72" loading="eager"></span><span class="auto-product__swatch-label">' + escapeHtml(value) + '</span>';
        shell.dataset.wpc5SafetyGalleryStyleThumb = String(entry.id);
      });
    });
  }
  function run() {
    var scope = root();
    if (!scope) return;
    ensureStyle();
    hydrateStyleChoices(scope);
    hydrateGallery(scope);
    if (scope.dataset.wpc5SafetyGalleryGalleryRestoreBound === 'true') return;
    scope.dataset.wpc5SafetyGalleryGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[name^="options["]')) {
        [0, 150, 600, 1200].forEach(function (delay) {
          window.setTimeout(run, delay);
        });
      }
    });
    var observer = new MutationObserver(function () {
      window.setTimeout(run, 25);
    });
    observer.observe(scope, { childList: true, subtree: true });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  var attempts = 0;
  var timer = window.setInterval(function () {
    attempts += 1;
    run();
    if (attempts >= 100) window.clearInterval(timer);
  }, 150);
})();
// END seibertronwpc5SafetyGalleryGalleryRestore20260714
